import { defineStore } from 'pinia';
import type { TextModePatientInfo } from '../types/text-mode.types';

export interface PatientState {
  patient: TextModePatientInfo | null;
}

export const usePatientStore = defineStore('textModePatient', {
  state: (): PatientState => ({
    patient: null,
  }),

  actions: {
    setPatient(patient: TextModePatientInfo | null | undefined): void {
      const existingId = this.patient?.id;

      if (!patient) {
        this.patient = existingId ? { id: existingId } : null;
        return;
      }

      const incomingId = typeof patient.id === 'string' ? patient.id.trim() : patient.id;
      this.patient = {
        ...patient,
        id: incomingId || existingId || null,
      };
    },

    setPatientId(id: string): void {
      const trimmedId = id.trim();
      this.patient = {
        ...(this.patient ?? {}),
        id: trimmedId.length > 0 ? trimmedId : null,
      };
    },

    reset(): void {
      this.patient = null;
    },

    resume(payload: PatientState): void {
      Object.assign(this, payload);
    },
  },
});
